import { USUARIO } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null
};

export default function usuariosReducer(state = initialState, action) {
    switch (action.type) {
        case USUARIO.BUSCAR:
            return { ...state, listado: action.payload };

        case USUARIO.AGREGAR:
            return { ...state, listado: [action.payload, ...state.listado] };

        case USUARIO.EDITAR:
            return {
                ...state,
                listado: state.listado.map(usuario =>
                    usuario._id === action.payload._id ? action.payload : usuario
                )
            };

        case USUARIO.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(usuario => usuario._id !== action.payload)
            };

        case USUARIO.DETALLES:
            return { ...state, detalles: action.payload };

        case USUARIO.LIMPIAR:
            return { ...state, detalles: null };

        default:
            return state;
    }
}
